interface IdEntry {
  label: string;
  value: string;
}

interface Props {
  ids: IdEntry[];
}

export default function LinkedIdsGrid({ ids }: Props) {
  if (!ids.length) return null;

  return (
    <div className="a4-keep-together mt-2 mb-1">
      <p className="text-[6.5px] font-bold uppercase tracking-wider text-gray-400 mb-0.5">Linked NeoHealthCard IDs</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-3 gap-y-px text-[7px]">
        {ids.map((entry, i) => (
          <div key={i} className="flex items-baseline gap-0.5 leading-tight min-w-0">
            <span className="text-gray-400 shrink-0 whitespace-nowrap">{entry.label}</span>
            <span className="text-gray-400 shrink-0">:</span>
            <span className="font-mono text-gray-600 truncate" title={entry.value}>{entry.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
